// 日本の世界史スポット。飛鳥・奈良の仏教受容、古墳時代の王権、室町の東アジア交易、
// 近世の築城技術、そして20世紀の戦争を1件ずつ代表させる。
// レコードの各フィールドの意味は src/historicSitesData.js の冒頭コメントを参照。

export const JAPAN_SITES = [
  {
    id: 'horyuji',
    name: '法隆寺',
    nameEn: 'Hōryū-ji',
    lat: 34.6147, lng: 135.7348, elevationM: 50,
    region: 'japan', era: 'ancient',
    country: '日本（奈良県斑鳩町）',
    civilization: '飛鳥時代・推古朝',
    yearLabel: '607年創建と伝わる / 7世紀後半に再建',
    whcYear: 1993,
    whcNote: '「法隆寺地域の仏教建造物」',
    emoji: '🛕',
    facts: [
      { label: '構造', value: '現存する世界最古級の木造建築群' },
    ],
    summary:
      '推古天皇と厩戸王（聖徳太子）の発願により607年に創建されたと伝わる寺院。現存する金堂・五重塔・中門・回廊は7世紀後半の再建とみられ、木造建築としては世界でも最古の部類に入る。柱の中ほどがふくらむエンタシスや雲斗雲肘木といった意匠には、中国の南北朝から朝鮮半島を経て伝わった様式が色濃く残り、6世紀の仏教公伝とともに大陸の技術と思想が日本へ流れ込んだことを今に伝える。1993年、姫路城とともに日本で最初の世界文化遺産に登録された。',
    quiz: {
      statement: '法隆寺の金堂と五重塔は、創建当時（607年）の建物がそのまま現存している。',
      answer: false,
      explain: '『日本書紀』は670年の焼失を伝えており、現存する西院伽藍は7世紀後半の再建とみられます。それでも世界最古級の木造建築であることに変わりはありません。',
    },
  },
  {
    id: 'todaiji',
    name: '東大寺 大仏殿',
    nameEn: 'Tōdai-ji',
    lat: 34.6889, lng: 135.8398, elevationM: 100,
    region: 'japan', era: 'ancient',
    country: '日本（奈良県奈良市）',
    civilization: '奈良時代・聖武天皇',
    yearLabel: '752年 大仏開眼供養 / 現在の大仏殿は1709年再建',
    whcYear: 1998,
    whcNote: '「古都奈良の文化財」の一部',
    emoji: '🛕',
    facts: [
      { label: '大仏', value: '盧舎那仏坐像・高さ約15m' },
    ],
    summary:
      '疫病と飢饉、政変に揺れた8世紀の日本で、聖武天皇が「鎮護国家」を掲げて建立した官立寺院。743年の大仏造立の詔を受けて盧舎那仏の鋳造が始まり、752年にはインド僧菩提僊那を導師として開眼供養が営まれた。全国に置かれた国分寺・国分尼寺の総本山にあたり、律令国家が仏教を統治の柱に据えたことを示している。現在の大仏殿は1709年の再建で、財政難から間口は創建時の約3分の2に縮んだが、それでも世界有数の規模を誇る木造建築である。',
    quiz: {
      statement: '現在の東大寺大仏殿は、奈良時代に建てられた当時のままの大きさである。',
      answer: false,
      explain: '大仏殿は源平の争乱と戦国期の2度焼失し、現在の建物は1709年（江戸時代）の再建です。財政難のため間口は創建時の約3分の2に縮小されました。',
    },
  },
  {
    id: 'daisenryo-kofun',
    name: '大仙陵古墳（仁徳天皇陵）',
    nameEn: 'Daisenryō Kofun',
    lat: 34.5645, lng: 135.4877, elevationM: 10,
    region: 'japan', era: 'ancient',
    country: '日本（大阪府堺市）',
    civilization: '古墳時代・ヤマト王権',
    yearLabel: '5世紀中頃',
    whcYear: 2019,
    whcNote: '「百舌鳥・古市古墳群」の一部',
    emoji: '⛰',
    facts: [
      { label: '規模', value: '墳丘長 約486m・三重の濠' },
    ],
    summary:
      '墳丘長486mにおよぶ日本最大の前方後円墳で、三重の濠に囲まれる。クフ王のピラミッド、秦の始皇帝陵と並んで「世界三大墳墓」に数えられることがある。5世紀中頃の築造とみられ、東アジアの他地域には見られない鍵穴形の墳形は、ヤマト王権が各地の首長と結んだ政治秩序の象徴と考えられている。ちょうど『宋書』倭国伝に見える「倭の五王」が中国南朝へたびたび遣使し、朝鮮半島南部をめぐる立場を認めさせようとした時代にあたる。2019年に世界文化遺産へ登録された。',
    quiz: {
      statement: '前方後円墳は日本列島を中心に分布する独自の墳形で、中国の皇帝陵を写したものではない。',
      answer: true,
      explain: '前方後円墳は日本列島（および朝鮮半島南西部の一部）に見られる独自の墳形です。中国の陵墓は方形や円形の墳丘が基本で、鍵穴形は見られません。',
    },
  },
  {
    id: 'kinkakuji',
    name: '金閣寺（鹿苑寺）',
    nameEn: 'Kinkaku-ji',
    lat: 35.0394, lng: 135.7292, elevationM: 80,
    region: 'japan', era: 'medieval',
    country: '日本（京都府京都市）',
    civilization: '室町時代・北山文化',
    yearLabel: '1397年造営 / 1955年再建',
    whcYear: 1994,
    whcNote: '「古都京都の文化財」の一部',
    emoji: '🏯',
    summary:
      '室町幕府3代将軍足利義満が1397年に営んだ北山山荘が前身で、その死後に禅寺（鹿苑寺）となった。舎利殿「金閣」は、初層が寝殿造風、二層が武家造風、三層が禅宗様仏殿という三つの様式を積み重ねたもので、公家・武家・禅林の文化が融け合った北山文化を象徴する。義満は1401年に明へ使者を送り「日本国王」として冊封を受け、勘合貿易を開いた。その富がこの金箔の楼閣を支えている。1950年に放火で焼失し、1955年に再建された。',
    quiz: {
      statement: '金閣を建てた足利義満は、明の皇帝から「日本国王」に封じられ、勘合貿易を行った。',
      answer: true,
      explain: '義満は1401年に明へ使者を送り、翌年「日本国王」として冊封されました。倭寇と区別するための勘合を用いた朝貢貿易は、幕府の大きな財源となりました。',
    },
  },
  {
    id: 'himeji-castle',
    name: '姫路城',
    nameEn: 'Himeji Castle',
    lat: 34.8394, lng: 134.6939, elevationM: 40,
    region: 'japan', era: 'earlymodern',
    country: '日本（兵庫県姫路市）',
    civilization: '安土桃山〜江戸時代初期',
    yearLabel: '1609年 現在の連立式天守が完成',
    whcYear: 1993,
    emoji: '🏯',
    facts: [
      { label: '別名', value: '白鷺城' },
      { label: '現況', value: '現存12天守のひとつ' },
    ],
    summary:
      '関ヶ原の戦いののち播磨に入った池田輝政が、1601年から約8年をかけて大改修し、1609年に現在の連立式天守を完成させた。白漆喰総塗籠の外観から「白鷺城」と呼ばれる。西国の外様大名を抑える幕府の要として築かれ、迷路のように折れ曲がる螺旋状の縄張り、狭間や石落としなど、戦国末期に到達した築城技術の集大成となっている。戦災も大地震も免れ、創建時の天守がほぼそのまま残る数少ない城で、1993年に日本初の世界文化遺産となった。',
    quiz: {
      statement: '姫路城の天守は太平洋戦争の空襲で焼失し、鉄筋コンクリートで再建されたものである。',
      answer: false,
      explain: '姫路も空襲を受けましたが天守は焼け残り、現存12天守のひとつです。名古屋城や広島城の天守が戦災で失われて再建されたのとは異なります。',
    },
  },
  {
    id: 'shurijo',
    name: '首里城',
    nameEn: 'Shuri Castle',
    lat: 26.2170, lng: 127.7194, elevationM: 130,
    region: 'japan', era: 'earlymodern',
    country: '日本（沖縄県那覇市）',
    civilization: '琉球王国',
    yearLabel: '1429年 琉球王国成立 / 1879年 琉球処分',
    whcYear: 2000,
    whcNote: '「琉球王国のグスク及び関連遺産群」の一部',
    emoji: '🏯',
    facts: [
      { label: '現況', value: '2019年の火災で正殿が焼失し再建中' },
    ],
    summary:
      '1429年に尚巴志が三山を統一して成立した琉球王国の王城。明・清への朝貢と、日本・朝鮮・東南アジアを結ぶ中継貿易で栄え、「万国津梁（世界を結ぶ架け橋）」を掲げた海洋王国の中枢だった。正殿は中国建築の朱塗りや龍柱と、日本建築の木造軸組が融合した独自の様式をもつ。1609年の薩摩侵攻後も中国への朝貢は続き、1879年の琉球処分で王国は幕を閉じた。1945年の沖縄戦で焼失、1992年に復元されたが2019年の火災で再び正殿を失い、現在再建が進む。',
    quiz: {
      statement: '琉球王国は、明・清に朝貢しながら江戸時代には薩摩藩の支配も受けるという両属の状態にあった。',
      answer: true,
      explain: '1609年の薩摩侵攻の後も中国への朝貢は続けられ、幕藩体制と冊封体制の両方に属する形が、明治の琉球処分まで続きました。',
    },
  },
  {
    id: 'atomic-bomb-dome',
    name: '原爆ドーム',
    nameEn: 'Atomic Bomb Dome',
    lat: 34.3955, lng: 132.4536, elevationM: 5,
    region: 'japan', era: 'modern',
    country: '日本（広島県広島市）',
    civilization: '第二次世界大戦',
    yearLabel: '1915年建設 / 1945年8月6日 被爆',
    whcYear: 1996,
    emoji: '🕊',
    facts: [
      { label: '爆心地から', value: '約160m' },
    ],
    summary:
      'チェコの建築家ヤン・レツルの設計により、1915年に広島県物産陳列館として竣工したネオバロック風の建物。1945年8月6日午前8時15分、上空約600mで炸裂した原子爆弾の爆心地からわずか約160mにありながら、爆風をほぼ真上から受けたため、鉄骨のドームと外壁だけが崩れずに残った。核兵器が実戦で使われた事実と、その日に失われた十数万の命を伝える「負の世界遺産」として1996年に登録され、二度と繰り返さないという誓いの象徴となっている。',
    // 追悼施設: クイズも「NEW!」バッジも出さない。
    solemn: true,
    quiz: null,
  },
];
